import React from 'react'
import {Wrapper, Button} from './style'

const BCText = () => {
    return (
        <>
        <Wrapper>
            Interested in our Kits?
        </Wrapper>
        <Wrapper>
            Get in touch with us.
        </Wrapper>
        <Button to="#">
            Contact
        </Button>
        </>
    )
}

export default BCText
